import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import Dropzone from "react-dropzone";
import { Button } from "react-bootstrap";

// Set custom Styles
const customStyles = {
  dropzone: {
    position: "relative",
    height: "auto",
    borderWidth: "2px",
    borderColor: "rgb(194, 194, 194)",
    borderStyle: "dashed",
    borderRadius: "5px",
  },
  dropzoneText: {
    fontWeight: "normal",
    fontSize: "14px",
    color: "var(--base-color)",
    margin: "20px",
  },
};

const DropZone = ({ getFile, ...props }) => {
  const [file, setFile] = useState(null);
  const { t } = useTranslation(["global"]);

  const saveFile = (file = []) => {
    if (file?.length) {
      getFile(file);
      setFile(file);
    }
  };

  return (
    <React.Fragment>
      <div id="dropzoneContainer" style={customStyles.dropzone}>
        <Dropzone onDrop={saveFile} {...props}>
          {({ getRootProps, getInputProps, open }) => (
            <div
              className="text-center"
              id="dropzoneCsv"
              style={customStyles.dropzoneText}
            >
              <div {...getRootProps()} style={{ cursor: "pointer" }}>
                <div id="fileInformation">
                  <p className="mb-2" id="file Name">
                    {file?.[0]?.name || t("global:importCSV.dropFile")}
                    <br />
                    {file ? "" : t("global:importCSV.dropFileOr")}
                  </p>
                </div>
                <input {...getInputProps()} />
              </div>
              <Button
                id="importCsvUploadFile"
                className="btn btn-text btn-white mt-2"
                onClick={(e) => {
                  e.stopPropagation();
                  open();
                }}
              >
                {t("global:importCSV.uploadFile")}
              </Button>
            </div>
          )}
        </Dropzone>
      </div>
    </React.Fragment>
  );
};

DropZone.propTypes = {
  getFile: PropTypes.func,
};

DropZone.defaultProps = {
  getFile: () => {},
};

export default DropZone;
